import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/home/BannerSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/home/CategoryGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/home/Csotd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/prd-a/cs-mobile-next/app/components/home/QuickMenu.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/styles/home/index.module.scss");
